<script setup lang="ts">
defineProps<{
  title: string
  text: string
  value: number
}>()
</script>

<template>
  <div class="flex flex-col rounded-lg border px-4 pt-4">
    <div class="mb-3 rounded-sm border-b pb-3">
      <TypographyHeading
        class="text-sm leading-tight font-medium text-zinc-900"
      >
        {{ title }}
      </TypographyHeading>
      <p class="mt-1 text-xs text-zinc-600" v-text="text" />
    </div>
    <ChartScoreSingleBar :value status="success" />
  </div>
</template>
